import { ColumnDetails, ColumnType } from '../../../grid/types/common';
import { Column, ColumnKeys, UpdateRings } from '../types';
import { html } from 'lit';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { EnumListItem } from '../../../ui/gzEnumList/types';
import { Dependencies } from '../types/dependencies';
import { GridViewWebComponent } from '../../../grid/gridView';
import { dataGridStrings } from '../../../grid/utils/gridStrings';
import { translateFn } from '../../../utils/translator.helper';
import {gridCustomHtmlRenderer} from "../../../grid/utils/renderers";
import {htmlEncode} from "../../../utils/escape.utils";

const stagingProfilesOptions: EnumListItem[] = [
  {
    label: "",
    value: UpdateRings.PRODUCTION_RING,
    selected: false,
  },
  {
    label: "",
    value: UpdateRings.TEST1_RING,
    selected: false,
  },
  {
    label: "",
    value: UpdateRings.TEST2_RING,
    selected: false,
  }
]
export function stagingProfilesRenderer(grid: GridViewWebComponent<Column, ColumnKeys>, dependencies: Dependencies, rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {

  const stagingProfile = rowData?.item?.stagingProfile;
  const stagingProfileString = (stagingProfile && stagingProfile.length)
                               ? stagingProfile.map(ring => dependencies.translateUpdateRing(ring)).join(', ')
                               : dependencies.translateUpdateRing(UpdateRings.NONE);

  let cellValues, dropdownOptions;

  cellValues = rowData.item[columnDetails.key];

  if (isEmpty(cellValues)) {
    dropdownOptions = stagingProfilesOptions.map(option => {
      option.label = dependencies.translateUpdateRing(option.value);
      return option;
    });
  } else {
    dropdownOptions = stagingProfilesOptions.map(option => {

      if (cellValues.includes(option.value)) {
        option.selected = true;
      }
      option.label = dependencies.translateUpdateRing(option.value);
      return option;
    });
  }

  return html`<gz-grid-cell-edit
    class = "cell-label"
      .value = "${stagingProfileString}"
      .type = "${ColumnType.ENUM}"
      .confirmActionButtonString = "${dataGridStrings().enumColumnStrings.confirmString}"
      .filterOptions = "${dropdownOptions}"
      .allItemsLabel = "${translateFn('All')}"
      .canSelectAll = "${true}"
      .allowSelectNone = "${true}"
      @selectionChange = "${stagingProfilesSelectionChangeHandler.bind(this, columnDetails.key, grid)}"
    ></gz-grid-cell-edit>`;

}


export function versionRenderer(dependencies: Dependencies, rowData) {
  const { translateUpdateRing } = dependencies;
  const version = rowData?.item?.version;
  const vendorRings = rowData?.item?.vendorRings;
  const vendorRingsStrings = vendorRings ? vendorRings.map(translateUpdateRing) : [];
  const vendorRingsString = vendorRingsStrings.length > 0 ? ` [${vendorRingsStrings.join(', ')}]` : '';
  const firstVendorRing = vendorRingsStrings.length > 0 ? vendorRingsStrings[0] : '';
  const tooltipText = firstVendorRing ? `${translateFn('This ring is defined by Bitdefender.')} [***]` : version;
  return html`
      <gz-tooltip class="cell-label" tooltipText="${tooltipText}"><span>${version}${vendorRingsString}</span></gz-tooltip>
  `;
}

function stagingProfilesSelectionChangeHandler(key, grid, event) {
  grid.controller.view.updateKeyInEditedGridItemData(key, event.detail.selectedValues);
}
